// test832
(832 && 0);
